import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getHiddenVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getHiddenVariationMods";
import { getVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getVariationMods";
import { getVisualBuilderBasePayload } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { selectedVariations } from "@src/store/slices/variations";
import { mpVisualBuilderModVisibilityToggled } from "@src/utils/mixpanel";

export interface TrackModVisibilityToggledPayload {
  /** The state the mods acted on ended up in. */
  visibility: "hidden" | "shown";
}

/**
 * Dispatch AFTER the hidden set has changed — `hidden_mod_count` reports the
 * resulting count.
 *
 * The event says how many mods ended up hidden, not which ones or which control
 * did it: a per-row click and a bulk click on the same variation are
 * indistinguishable here. Splitting those apart again means re-adding a
 * discriminating property.
 */
export const trackModVisibilityToggled = createAsyncThunk<
  void,
  TrackModVisibilityToggledPayload
>(
  "experienceBuilder/tracking/modVisibilityToggled",
  (payload, { getState }) => {
    const state = getState();
    const basePayload = getVisualBuilderBasePayload(state);
    if (!basePayload) {
      return;
    }

    mpVisualBuilderModVisibilityToggled({
      ...basePayload,
      test_group_count: selectedVariations(state).length,
      mod_count: getVariationMods(state).length,
      builder_mode: experienceBuilderSlice.selectors.getDevice(state),
      visibility: payload.visibility,
      hidden_mod_count: getHiddenVariationMods(state).length,
    });
  }
);
